export default __webpack_public_path__ + "assets/models/3ebd07349834ec2b3bc46f314440eedf.gltf";